import {CatalogCard} from "@/widgets/catalog-card";
import useViewItemBatcher from "@/Hooks/useViewItemBatcher";
import styles from "../Editor.module.scss";

const CatalogCardBlock = ({items = []}) => {
    const {registerView} = useViewItemBatcher();

    if (!items.length) return null;

    return (
        <div className={styles.reProducts}>
            {items.map((product, index) => (
                <CatalogCard
                    key={index}
                    product={product}
                    index={index + 1}
                    className={styles.reCatalogCard}
                    registerView={registerView}
                />
            ))}
        </div>
    );
};

export default CatalogCardBlock;
